export default __webpack_public_path__ + "static/media/logo-simple.d52d99ac.svg";